<div class="mobile-header">
  <button mat-icon-button class="menu-button" (click)="toggleSidebar()">
    <mat-icon [svgIcon]="svgIconsEnum.BurgerMenu"></mat-icon>
  </button>
</div>
